import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { useSelector, useDispatch } from 'react-redux';
import {
  CircularProgress,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Grid
} from '@material-ui/core';

import {
  initPage,
  getRequestErrorsByPageSelector,
  getPageReadyByPageSelector
} from '../../store/api';
import { getAccountsSelector } from '../../store/accounts';

import withAlert from '../../hoc/withAlert';

import { Account } from './components';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  displayNone: { display: 'none' }
}));

const Accounts = props => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const pageReady = useSelector(
    getPageReadyByPageSelector(props.location.pathname)
  );
  const accountsData = useSelector(getAccountsSelector);

  useEffect(() => {
    const getData = async () => {
      await initPage(props.location.pathname, dispatch);
    };
    getData();
  }, [dispatch]);


  return (
    <React.Fragment>
      {pageReady === false && accountsData && (
        <div
          style={{
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center'
          }}>
          <CircularProgress disableShrink size={56} />
        </div>
      )}

      {pageReady !== false && accountsData && accountsData.length > 0 && (
        <div className={classes.root}>
          <div className={classes.content}>
            <Card>
              <CardHeader title="Список кредиторов" />
              <Divider />
              <CardContent>
                <Grid
                  container
                  direction="column"
                  justify="flex-start"
                  alignItems="stretch"
                  wrap="nowrap"
                  spacing={2}>
                  {accountsData.length > 0 &&
                    accountsData.map(account => (
                      <Grid item key={account.account_id}>
                        <Account account={account} />
                      </Grid>
                    ))}
                </Grid>
              </CardContent>
            </Card>
          </div>
        </div>
      )}
    </React.Fragment>
  );
};

export default withAlert(Accounts);
